<main>
  <h2>Code Distribution</h2>
  <h3>Decentralise your operational stack.</h3>
  <div class="cardrow">
    <div class="card org-screenshot">
      <div class="text">
        <h4 class="cardtitle">Org</h4>
        <p>Create DAOs and manage your team.</p>
      </div>
    </div>
    <div class="card pullpush-screenshot">
      <div class="text">
        <h4 class="cardtitle">Pull & push</h4>
        <p>Use git as usual.</p>
      </div>
    </div>
    <div class="card githubgitlab-screenshot">
      <div class="text">
        <h4 class="cardtitle">Github & Gitlab mirroring</h4>
        <p>Get started by mirroring your code.</p>
      </div>
    </div>
  </div>
</main>
